<template>
  <div class="memberorder">
    <Header msg="member" />

    <div class="mt-5 mb-5 container">
      <div class="row text-center d-flex justify-content-around">
        <div class="card" style="width: 18rem;">
          <img
            src="https://api-lunacy.icons8.com/api/assets/81ebea41-3d22-4c90-bfa2-276dd83717dd/List is empty.png"
            class="card-img-top"
            alt=""
          />
          <div class="card-body text-white">
            <h1 class="card-title">{{ donCho }}</h1>
            <p class="card-text">Đơn chờ</p>
          </div>
        </div>

        <div class="card" style="width: 18rem;">
          <img
            src="https://api-lunacy.icons8.com/api/assets/d2af4bb8-e5ba-4975-a3aa-82457352d1c7/Success.png"
            class="card-img-top"
            alt=""
          />
          <div class="card-body text-white">
            <h1 class="card-title">{{ donDuyet }}</h1>
            <p class="card-text">Đơn duyệt</p>
          </div>
        </div>

        <div class="card" style="width: 18rem;">
          <img
            src="https://api-lunacy.icons8.com/api/assets/07f0227a-f40c-4140-9b80-b644d07c23f9/Unsubscribed.png"
            class="card-img-top"
            alt=""
          />
          <div class="card-body text-white">
            <h1 class="card-title">{{ allOrder.length }}</h1>
            <p class="card-text">Tổng đơn</p>
          </div>
        </div>
      </div>
    </div>

    <!-- DON CHO -->

    <!-- start label-->
    <div class="mt-5 container">
      <h1 class="text-center">Quản lý đơn chờ</h1>
    </div>
    <!-- end -->

    <!-- start table v2 -->
    <div id="table-responsive" class="container">
      <table class="table table-response table-bordered table-striped mx-auto">
        <tr class="bg-dark text-white table-striped">
          <td>#</td>
          <td>Tình trạng đơn</td>
          <td>Mã vận đơn</td>
          <td>Tên</td>
          <td>Số điện thoại</td>
          <td>Mã sách in</td>
          <td>Mã sách photo</td>
          <td>Mã sách tặng</td>
          <td>Tổng tiền</td>
          <td>Người tạo</td>
          <td>Ngày tạo</td>
          <td></td>
        </tr>
        <tr v-for="(e, i) in allOrder" :key="i">
          <td v-if="e.status == 'no'">{{ i }}</td>
          <td v-if="e.status == 'no'">{{ e.ctv_id }}</td>
          <td v-if="e.status == 'no'">{{ e.homebook }}</td>
          <td v-if="e.status == 'no'">{{ e.name }}</td>
          <td v-if="e.status == 'no'">{{ e.phone_1 }}</td>
          <td v-if="e.status == 'no'">{{ e.print }}</td>
          <td v-if="e.status == 'no'">{{ e.photo }}</td>
          <td v-if="e.status == 'no'">{{ e.gift }}</td>
          <td v-if="e.status == 'no'">{{ e.note }}</td>
          <td v-if="e.status == 'no'">{{ e.owned }}</td>
          <td v-if="e.status == 'no'">{{ e.date }}</td>
          <td v-if="e.status == 'no'">
            <button
              @click="detailOrder = e"
              class="btn btn-block bg-danger text-white"
              type="button"
              data-toggle="modal"
              data-target="#exampleModal"
            >
              Chi tiết
            </button>
          </td>
        </tr>
      </table>
    </div>
    <!-- end -->

    <div class="d-flex justify-content-center container">
      <button class="btn btn-danger" @click="backWait()">back</button>
      <button class="btn btn-dark">{{ 0 }}</button>
      <button class="btn btn-success">{{ numberPageWait }}</button>
      <button class="btn btn-dark">{{ maxPageWait }}</button>
      <button class="btn btn-primary" @click="nextWait()">next</button>
    </div>

    <!-- start modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Thông tin chi tiết
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <h4>Tình trạng đơn</h4>
              <input type="text" v-model="detailOrder.ctv_id" />
            </div>
            <!-- <div>
             <h4>Mã vận đơn</h4>
             <input type="text" v-model="detailOrder.homebook" disabled>
          </div> -->
            <div>
              <h4>Tên khách hàng</h4>
              <input type="text" v-model="detailOrder.name" />
            </div>
            <div>
              <h4>Địa chỉ</h4>
              <input type="text" v-model="detailOrder.address" />
            </div>
            <div>
              <h4>Số điện thoại 1</h4>
              <input type="text" v-model="detailOrder.phone_1" />
            </div>
            <div>
              <h4>Số điện thoại 2</h4>
              <input type="text" v-model="detailOrder.phone_2" />
            </div>
            <div>
              <h4>Facebook</h4>
              <input type="text" v-model="detailOrder.fb" />
            </div>
            <div>
              <h4>Link Facebook</h4>
              <input type="text" v-model="detailOrder.link" />
            </div>
            <div>
              <h4>Email</h4>
              <input type="text" v-model="detailOrder.email" />
            </div>
            <div>
              <h4>Mã sách in</h4>
              <input type="text" v-model="detailOrder.print" />
            </div>
            <div>
              <h4>Mã sách photo</h4>
              <input type="text" v-model="detailOrder.photo" />
            </div>
            <div>
              <h4>Mã sách tặng</h4>
              <input type="text" v-model="detailOrder.gift" />
            </div>
            <div>
              <h4>Tổng tiền</h4>
              <input type="text" v-model="detailOrder.note" />
            </div>
            <div>
              <h4>Ngày tạo</h4>
              <input type="text" v-model="detailOrder.date" disabled />
            </div>

            <!-- <div>
             <h4>Người tạo</h4>
             <input type="text" v-model="detailOrder.owned" disabled>
          </div> -->
            <div>
              <h4>Tình trạng</h4>
              <input type="text" v-model="detailOrder.status" disabled />
            </div>
            <!-- <div>
             <h4>Thuộc</h4>
             <input type="text" v-model="detailOrder.ctv" disabled>
          </div> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Đóng
            </button>
            <button
              @click="saved()"
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Lưu
            </button>
            <button
              @click="deleted()"
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              Xóa
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->

    <!-- <div class="d-flex justify-content-center">
      <button class="btn btn-danger" @click="back()">back</button>
      <button class="btn btn-dark">{{numberPage}}</button>
      <button class="btn btn-primary" @click="next()">next</button>
  </div> -->

    <!-- DON DUYET -->

    <!-- start label-->
    <div class="mt-5 container">
      <h1 class="text-center">Quản lý đơn duyệt</h1>
    </div>
    <!-- end -->

    <!-- start table v2 -->
    <div id="table-responsive" class="container">
      <table class="table table-response table-bordered table-striped mx-auto">
        <tr class="bg-dark text-white table-striped">
          <td>#</td>
          <td>Tình trạng đơn</td>
          <td>Mã vận đơn</td>
          <td>Tên</td>
          <td>Số điện thoại</td>
          <td>Mã sách in</td>
          <td>Mã sách photo</td>
          <td>Mã sách tặng</td>
          <td>Tổng tiền</td>
          <td>Người tạo</td>
          <td>Ngày tạo</td>
          <td></td>
        </tr>
        <tr v-for="(e, i) in partOrder" :key="i">
          <td v-if="e.status == 'yes'">{{ i }}</td>
          <td v-if="e.status == 'yes'">{{ e.ctv_id }}</td>
          <td v-if="e.status == 'yes'">{{ e.homebook }}</td>
          <td v-if="e.status == 'yes'">{{ e.name }}</td>
          <td v-if="e.status == 'yes'">{{ e.phone_1 }}</td>
          <td v-if="e.status == 'yes'">{{ e.print }}</td>
          <td v-if="e.status == 'yes'">{{ e.photo }}</td>
          <td v-if="e.status == 'yes'">{{ e.gift }}</td>
          <td v-if="e.status == 'yes'">{{ e.note }}</td>
          <td v-if="e.status == 'yes'">{{ e.owned }}</td>
          <td v-if="e.status == 'yes'">{{ e.date }}</td>
          <td v-if="e.status == 'yes'">
            <button
              @click="detailOrder = e"
              class="btn btn-block bg-danger text-white"
              type="button"
              data-toggle="modal"
              data-target="#exampleModal1"
            >
              Chi tiết
            </button>
          </td>
        </tr>
      </table>
    </div>
    <!-- end -->

    <div class="d-flex justify-content-center">
      <button class="btn btn-danger" @click="back()">back</button>
      <button class="btn btn-dark">{{ 0 }}</button>
      <button class="btn btn-success">{{ numberPage }}</button>
      <button class="btn btn-dark">{{ maxPage }}</button>
      <button class="btn btn-primary" @click="next()">next</button>
    </div>

    <!-- start modal -->
    <div
      class="modal fade"
      id="exampleModal1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Thông tin chi tiết
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <h4>Tình trạng đơn</h4>
              <input type="text" v-model="detailOrder.ctv_id" />
            </div>
            <!-- <div>
             <h4>Mã vận đơn</h4>
             <input type="text" v-model="detailOrder.homebook" disabled>
          </div> -->
            <div>
              <h4>Tên khách hàng</h4>
              <input type="text" v-model="detailOrder.name" disabled />
            </div>
            <div>
              <h4>Địa chỉ</h4>
              <input type="text" v-model="detailOrder.address" disabled />
            </div>
            <div>
              <h4>Số điện thoại 1</h4>
              <input type="text" v-model="detailOrder.phone_1" disabled />
            </div>
            <div>
              <h4>Số điện thoại 2</h4>
              <input type="text" v-model="detailOrder.phone_2" disabled />
            </div>
            <div>
              <h4>Facebook</h4>
              <input type="text" v-model="detailOrder.fb" disabled />
            </div>
            <div>
              <h4>Link Facebook</h4>
              <input type="text" v-model="detailOrder.link" disabled />
            </div>
            <div>
              <h4>Email</h4>
              <input type="text" v-model="detailOrder.email" disabled />
            </div>
            <div>
              <h4>Mã sách in</h4>
              <input type="text" v-model="detailOrder.print" disabled />
            </div>
            <div>
              <h4>Mã sách photo</h4>
              <input type="text" v-model="detailOrder.photo" disabled />
            </div>
            <div>
              <h4>Mã sách tặng</h4>
              <input type="text" v-model="detailOrder.gift" disabled />
            </div>
            <div>
              <h4>Ngày tạo</h4>
              <input type="text" v-model="detailOrder.date" disabled />
            </div>
            <div>
              <h4>Tổng tiền</h4>
              <input type="text" v-model="detailOrder.note" disabled />
            </div>
            <!-- <div>
             <h4>Người tạo</h4>
             <input type="text" v-model="detailOrder.owned" disabled>
          </div> -->
            <div>
              <h4>Tình trạng</h4>
              <input type="text" v-model="detailOrder.status" disabled />
            </div>
            <!-- <div>
             <h4>Thuộc</h4>
             <input type="text" v-model="detailOrder.ctv" disabled>
          </div> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Đóng
            </button>
            <button
              @click="saved()"
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  },

  data() {
    return {
      donCho: 0,
      donDuyet: 0,
      allOrder: [],
      partOrder: [],
      partOrderWait: [],
      detailOrder: {},
      currentPage: 0,
      currentPageWait: 0,
      maxPage: 0,
      maxPageWait: 0,
      numberPage: 0,
      numberPageWait: 0
    };
  },

  methods: {
    nextWait() {
      if (this.numberPageWait >= 0 && this.numberPageWait < this.maxPageWait) {
        this.currentPageWait += 15;
        this.partOrderWait = this.allOrder
          .filter(e => {
            return e.status == "no";
          })
          .slice(this.currentPageWait, this.currentPageWait + 15);
        this.numberPageWait++;
      }
    },

    backWait() {
      if (
        this.numberPageWait >= 0 &&
        this.numberPageWait <= this.maxPageWait &&
        this.currentPageWait >= 15
      ) {
        this.currentPageWait -= 15;
        this.partOrderWait = this.allOrder
          .filter(e => {
            return e.status == "no";
          })
          .slice(this.currentPageWait, this.currentPageWait + 15);
        this.numberPageWait--;
      }
    },
    next() {
      if (this.numberPage >= 0 && this.numberPage < this.maxPage) {
        this.currentPage += 15;
        this.partOrder = this.allOrder.slice(
          this.currentPage,
          this.currentPage + 15
        );
        this.numberPage++;
      }
    },

    back() {
      if (
        this.numberPage >= 0 &&
        this.numberPage <= this.maxPage &&
        this.currentPage >= 15
      ) {
        this.currentPage -= 15;
        this.partOrder = this.allOrder.slice(
          this.currentPage,
          this.currentPage + 15
        );
        this.numberPage--;
      }
    },

    deleted() {
      axios
        .delete(
          "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders/id/" +
            this.detailOrder.id
        )
        .then(response => {
          alert("Xóa thành công");
          this.allOrder = this.allOrder.filter(e => {
            return e.id != this.detailOrder.id;
          });
        });
    },

    saved() {
      axios
        .patch(
          "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders/id/" +
            this.detailOrder.id,
          this.detailOrder
        )
        .then(response => {
          alert("sửa thành công");
        });
    }
  },

  created() {
    axios
      .get(
        "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders/search?owned=" +
          sessionStorage.getItem("id")
      )
      .then(response => {
        this.allOrder = response.data.reverse();
        this.donCho = this.allOrder.filter(e => {
          return e.status == "no";
        }).length;
        this.donDuyet = this.allOrder.filter(e => {
          return e.status == "yes";
        }).length;
        this.partOrder = this.allOrder.slice(this.currentPage, 15);
        this.maxPage = Math.floor(this.allOrder.length / 15);

        // Đơn chưa duyệt
        this.partOrderWait = this.allOrder
          .filter(e => {
            return e.status == "no";
          })
          .slice(this.currentPageWait, 15);
        this.maxPageWait = Math.floor(
          response.data.filter(e => {
            return e.status == "no";
          }).length /
            15 /
            2
        );
      });
  }
};
</script>

<style lang="css" scoped>
input {
  text-align: left !important;
  min-width: 100%;
  padding: 0.5rem 1rem;
}
h4 {
  margin-top: 1rem;
  background: #27ae60;
  border-radius: 4px;
  color: white;
  padding: 0.5rem 1rem;
}
table,
tr,
td {
  margin: 0;
  padding: 0;
}
.short {
  max-width: 100%;
}
.checkbox label:after,
.radio label:after {
  content: "";
  display: table;
  clear: both;
}
.checkbox .cr,
.radio .cr {
  position: relative;
  display: inline-block;
  border: 1px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.3em;
  height: 1.3em;
  float: left;
  margin-right: 0.5em;
}
.radio .cr {
  border-radius: 50%;
}
.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
  position: absolute;
  font-size: 0.8em;
  line-height: 0;
  top: 50%;
  left: 20%;
}
.radio .cr .cr-icon {
  margin-left: 0.04em;
}
.checkbox label input[type="checkbox"],
.radio label input[type="radio"] {
  display: none;
}
.checkbox label input[type="checkbox"] + .cr > .cr-icon,
.radio label input[type="radio"] + .cr > .cr-icon {
  transform: scale(3) rotateZ(-20deg);
  opacity: 0;
  transition: all 0.3s ease-in;
}
.checkbox label input[type="checkbox"]:checked + .cr > .cr-icon,
.radio label input[type="radio"]:checked + .cr > .cr-icon {
  transform: scale(1) rotateZ(0deg);
  opacity: 1;
}
.checkbox label input[type="checkbox"]:disabled + .cr,
.radio label input[type="radio"]:disabled + .cr {
  opacity: 0.5;
}
/* card */
.card {
  border: none !important;
  box-shadow: 1px 16px 32px 5px rgba(0, 0, 0, 0.1);
}
.card-body {
  background: #3498db;
}
</style>



// WEBPACK FOOTER //
// src/components/MemberOrder.vue